var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_8630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7465 13.7995C25.7465 12.9158 25.6749 12.0273 25.522 11.1579H13.26V16.164H20.2819C19.9905 17.7785 19.0543 19.2068 17.6833 20.1144V23.3626H21.8726C24.3326 21.0984 25.7465 17.7546 25.7465 13.7995Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2599 26.5009C16.7661 26.5009 19.7229 25.3497 21.8773 23.3625L17.688 20.1143C16.5225 20.9073 15.0178 21.3563 13.2647 21.3563C9.87321 21.3563 6.99759 19.0682 5.96581 15.992H1.64282V19.3405C3.84969 23.7304 8.34464 26.5009 13.2599 26.5009Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96109 15.992C5.41654 14.3774 5.41654 12.6291 5.96109 11.0146V7.66605H1.64289C-0.200949 11.3394 -0.200949 15.6671 1.64289 19.3405L5.96109 15.992Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2599 5.64546C15.1133 5.6168 16.9046 6.31421 18.2469 7.59439L21.9585 3.88283C19.6083 1.67596 16.489 0.462662 13.2599 0.500876C8.34464 0.500876 3.84969 3.27141 1.64282 7.66604L5.96103 11.0146C6.98804 7.93354 9.86843 5.64546 13.2599 5.64546Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_8630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e523b6a3227b6430ae36e663bd0468eb.svg";
export { ForwardRef as ReactComponent };